import styled,{css} from "styled-components";

export const ContainerLoading = styled.div`
    flex: auto;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const Container = styled.div`
    margin-left: 5rem;
    margin-right: 1rem;
`;

export const Content = styled.div`
    margin-bottom: 2.5rem;
    overflow: scroll;
    
    &::-webkit-scrollbar-track {
        background-color: #FFF;
    }

    &::-webkit-scrollbar {
        width: 5px;
        height: 5px;
    }

    &::-webkit-scrollbar-thumb {
        background: #C3C3C3;
        border-radius: 4px;
    }

    scrollbar-width: thin;
    scrollbar-color: #C3C3C3;
    scrollbar-track-color: #FFF;  
`;

export const Table = styled.table`
    width: 100%;
    font-size: 0.9rem;
    margin: 25px 0;
    color: var(--colorFontsCardsDashboard);

    thead{
        background: var(--colorBackgroundCardsDashboard);

        tr{
            th{
                font-size: 17px;
                text-align: left;

                @media(max-width: 800px){
                    font-size: 15px;
                }

                @media(max-width: 700px){
                    font-size: 13px;
                }
            }

            th:last-child{
                text-align: center;
            }
            

            th:nth-child(5){
                text-align: center;
            }
        }
    }

    tbody{
        tr{
            border-bottom: 1px solid #DDD;

            &:nth-child(even){
                background: #f2f2f2;
            }

            td{
                text-align: left;
            }

            td:first-child{
                text-align: center;
            }

            td:last-child{
                text-align: center;
            }

            td:nth-child(5){
                text-align: center;
            }

            .A{
                background-color: #2e9699;
                color: #fff;
             }

             .B{
                background-color: #F0E68C;
             }

             .C{
                background-color: #e05f59;
                color: #fff;
             }

            .edit{
                display: flex;
                justify-content: space-around;
                align-items: center;

                svg{
                    cursor: pointer;
                }
            }
        }
    }
    
    th, td{
        padding: 0.15rem 0.35rem;
        font-size: 15px;
        height: 40px;

        @media(max-width: 800px){
            font-size: 13px;
        }

        @media(max-width: 700px){
            font-size: 12px;
        }
    }

    tfoot{
        text-align: left;
    }
`;

export const BarContainer = styled.div`
    flex: auto;
    height: 100%;
    border: 0.2px solid #E6E6E6;

    display: flex;
    align-items: center;
    justify-content: flex-start;

    
    @media(max-width: 800px){
        display: none;
    }
`;

export const Bar = styled.div`
    height: 100%;
    background: #2e9699;
    color: #FFF;
    
    display: flex;
    align-items: center;
    justify-content: center;

    ${props => props.percent && css`
        width: ${props.percent + '%'};
    `};
`;

export const ValueContainer = styled.div`
    display: none;

    @media(max-width: 800px){
        display: flex;
    }
`;

export const Button = styled.div`
    padding: 0.5rem;
    border-radius: 5px;
    background: #2e9699;
    color: #FFF;
    margin: 1rem auto;
    max-width: 300px;
    cursor: pointer;
    opacity: ${props => props.loadingButton ? 0.5 : 1};
    pointer-events: ${props => props.loadingButton ? 'none' : 'all'};
    text-align: center;
`;
